import * as React from 'react';
import { ApplicationState } from "../../redux/reducers";
import { connect } from "react-redux"
import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Theme } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import NumberField from "../controls/NumberField";
import { IEvent } from "../../interfaces/IEvent";
import { useState } from "react";
import { enums } from "../../enums/enums";
import SubmitButton from "../controls/SubmitButton";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { Defaults } from "../../defaults/Defaults";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { setSolicitud, setSolicitudCopia } from "../../redux/actions/solicitudActions";
import { saveMercancias } from "../../redux/actions/mercanciaActions";
import { setRecoleccionDestino, setRecoleccionOrigen } from "../../redux/actions/recoleccionActions";
import Help, { IHelp } from '../help/Help';
import { ICliente } from '../../entities/catalogos/ICliente';
import { useSnackbar } from 'notistack';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import { IUsuario } from "../../entities/catalogos/IUsuario";
import { Mercancia } from "../../entities/solicitudes/Mercancia";
import { ServicioAdicional } from '../../entities/catalogos/ServicioAdicional';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Checkbox from "@material-ui/core/Checkbox";
import swal from 'sweetalert2'
import useCommonApi from '../../api/useCommonApi'
import { ISolicitudDto } from '../../entities/solicitudes/SolicitudDto';
import LoadingDialog from '../controls/LoadingDialog';
import { unescape } from 'lodash';
import {setServiciosAdicionales} from "../../blocks/utility";
import { ICotizacionDto } from '../../entities/cotizaciones/ICotizacionDto';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({

        heading: {
            fontSize: "0.875rem",
            color: "#00653b",
            fontWeight: theme.typography.fontWeightBold,
            borderBottom: "2px solid #00653b"
        },
        border: {
            fontSize: theme.typography.pxToRem(20),
            fontWeight: theme.typography.fontWeightBold,
            textAlign: "center"
        },
        actions: {
            width: "100%",
            textAlign: "right",
            paddingTop: "20px",
            backgroundColor: "#ccc"
        },
        link: {
            color: "#0094ff",
            fontSize: "12px",
            fontWeight: 500,
            cursor: "pointer"
        },
    }),
);

interface OwnProps {
    cotizacionId: number
    siguienteSeccion: (estatusId: number, cotizacionCopia: Solicitud, cotizacionId: number) => void
    datosRemitente?: any
    datosDestinatario?: any
    handleChangeFields: () => void
}

interface StateProps {
    ayuda: IHelp
    solicitud: Solicitud
    usuario: IUsuario
    mercancias: Mercancia[]
    solicitudCopia: Solicitud
    serviciosAdicionales: ServicioAdicional[]
    cliente: ICliente
    solicitudDTO: any
    cotizacionDTO: any
}

interface DispatchProps {
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
    saveMercancias: typeof saveMercancias
    setRecoleccionOrigen: typeof setRecoleccionOrigen
    setRecoleccionDestino: typeof setRecoleccionDestino
}


type Props = OwnProps & StateProps & DispatchProps

const Markup = (props: Props) => {
    const classes = useStyles();
    const [aceptaTerminos, setAceptaTerminos] = useState(false);
    const apiSourceCommon = useCommonApi();
    const [showLoading, setLoading] = useState(false);
    let tipoMarkup = 0;
    if (props.solicitudCopia.markupMonto !== null && props.solicitudCopia.markupMonto !== undefined)
        tipoMarkup = 0
    if (props.solicitudCopia.markupPorcentaje !== null && props.solicitudCopia.markupPorcentaje !== undefined)
        tipoMarkup = 1

    if(props.solicitudCopia.tipoMarkupId !== undefined && props.solicitudCopia.tipoMarkupId!== null)
        tipoMarkup = props.solicitudCopia.tipoMarkupId;
    const [cotizacion, setCotizacion] = useState(props.solicitudCopia);
    const [tipo, setTipo] = useState(tipoMarkup);
    const { enqueueSnackbar } = useSnackbar();
    
    const handleChange = (event: IEvent) => {
        const name = event.target.name || "";
        const nuevaCotizacion = new Solicitud({ ...cotizacion, [name]: event.target.value });
        const nuevaCot = new Solicitud(props.solicitud);
        nuevaCot.markupMonto = nuevaCotizacion.markupMonto;
        nuevaCot.markupPorcentaje = nuevaCotizacion.markupPorcentaje;
        nuevaCot.tipoMarkupId = tipoMarkup;
        props.setSolicitudCopia(nuevaCotizacion);
        setCotizacion(nuevaCotizacion);
        
        props.setSolicitud(nuevaCot);
        if(props.solicitud.tipoSolicitud !== "cotizacion"){
            props.handleChangeFields();
        }
    };

    const handleChangeTipo = (event: React.ChangeEvent<HTMLInputElement> | IEvent) => {
        setTipo(Number(event.target.value));

        const nuevaCotizacion = new Solicitud({ ...cotizacion, markupMonto: null, markupPorcentaje: null, tipoMarkupId: Number(event.target.value) });

        setSolicitudCopia(nuevaCotizacion);
        setCotizacion(nuevaCotizacion);
    }

    const handleSiguienteSeccion = () => {
        /* if (!aceptaTerminos) {
            swal.fire({
                titleText: traducirMessage(276), // '¡Atención!',
                text: traducirMessage(95), // "Favor de aceptar los términos y condiciones.",
                type: 'warning',
            });
            return;
        } */

        const nuevaCotizacionValida = new Solicitud({ ...props.solicitud });
        nuevaCotizacionValida.montoPesoFacturado = props.cotizacionId
         
        if (cotizacion !== undefined && cotizacion.markupMonto != undefined && props.cliente.clienteConfiguracionMarkup.porcentajeTope !== null && tipo === 0) {
            let montoPorcentajeMarkupCliente = nuevaCotizacionValida.montoPesoFacturado !== undefined ? nuevaCotizacionValida.montoPesoFacturado * (props.cliente.clienteConfiguracionMarkup.porcentajeTope/100) : 0;
            if(cotizacion.markupMonto > montoPorcentajeMarkupCliente){    
            let mensaje = traducirMessage(185).replace("XXX",props.cliente.clienteConfiguracionMarkup.porcentajeTope +'%'); //'El monto no corresponde al XXX Markup'  
                enqueueSnackbar(mensaje, { variant: "error" });
                return;
            }
        }

        if (cotizacion !== undefined && cotizacion.markupPorcentaje != undefined && props.cliente.clienteConfiguracionMarkup.porcentajeTope !== null && tipo === 1) {
            if(props.cliente.clienteConfiguracionMarkup.porcentajeTope < cotizacion.markupPorcentaje){    
            let mensaje = traducirMessage(186) //'Máximo Markup permitido' 
                    + ' ' + props.cliente.clienteConfiguracionMarkup.porcentajeTope +'%';
                enqueueSnackbar(mensaje, { variant: "error" });
                return;
            }
        }

        let porcentajeMarkup = 0;
        let montoMarkup = 0;
        if (cotizacion !== undefined && cotizacion.markupPorcentaje != undefined) {
            porcentajeMarkup = cotizacion.markupPorcentaje;
        }
        if (cotizacion !== undefined && cotizacion.markupMonto != undefined) {
            montoMarkup = cotizacion.markupMonto;
        }
        nuevaCotizacionValida.tipoMarkupId = tipoMarkup;
        props.siguienteSeccion(montoMarkup, nuevaCotizacionValida, porcentajeMarkup);
        return ; 
    };

    const aceptaterminos = () => {
        window.open('http://ndocum.almex.com.mx/documentacion/pages/GenerarPDF.aspx?TipoPDF=8');
    }

    const handleTerminos = () => {
        setAceptaTerminos(true);
    }
    return (<>
        <Box>
            <Help comments="Markup" ayuda={props.ayuda} customStyle={{ top: "0px", right: "0px" }} />
        </Box>
        <Box p={3}>
            <Grid item xs={11} sm={12}>
                <FormControl component="fieldset">
                    <FormLabel component="legend">
                        {/* Tipo */
                            traducirLabel(296)}
                    </FormLabel>
                    <RadioGroup row name="tipoId" value={tipo} onChange={handleChangeTipo}>
                    {/* Monto */}
                        <FormControlLabel value={0} label={traducirLabel(187)}
                            control={<Radio color="primary" size="small" />} />
                            {/* Porcentaje */}
                        <FormControlLabel value={1} label={traducirLabel(235)}
                            control={<Radio color="primary" size="small" />} />
                    </RadioGroup>
                </FormControl>
            </Grid>
        </Box>

        <ValidatorForm onSubmit={handleSiguienteSeccion}>
            <Box p={3}>
                <Grid container spacing={4} justify="center">
                    <Grid item xs={11} md={6}>
                        <TextValidator
                            label={traducirLabel(187)}
                            value={cotizacion?.markupMonto}
                            name="markupMonto"
                            onChange={handleChange}
                            variant="filled"
                            fullWidth
                            disabled={tipo === 1}
                            errorMessages={[traducirLabel(126)]}
                            InputProps={{
                                inputComponent: NumberField,
                                inputProps: { prefix: "$", maxLength: 8 },
                            }}
                        />
                    </Grid>

                    <Grid item xs={11} md={6}>
                        <TextValidator
                            label={traducirLabel(235)}
                            value={cotizacion?.markupPorcentaje}
                            name="markupPorcentaje"
                            onChange={handleChange}
                            variant="filled"
                            fullWidth
                            disabled={tipo === 0}
                            errorMessages={[traducirLabel(126)]}
                            InputProps={{
                                inputComponent: NumberField,
                                inputProps: { suffix: "%", maxLength: 5 },
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container className={classes.actions} style={{ backgroundColor: "white", padding: "10px" }}>
                <Grid item xs={8}>
                </Grid>
                {props.solicitud.tipoSolicitud !== "cotizacion" &&
                    <Grid item xs={4}>
                        <SubmitButton label={traducirButton(15)} />
                    </Grid>
                }
                {props.solicitud.tipoSolicitud === "cotizacion" &&
                    <Grid item xs={4}>
                        <SubmitButton label={traducirLabel(332)} />
                    </Grid>
                }
            </Grid>
                {/* <SubmitButton label={traducirLabel(151)} /> */}
            </Box>
        </ValidatorForm>
        {showLoading &&
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    ayuda: state.ayuda,
    solicitud: state.solicitud,
    usuario: state.usuario,
    mercancias: state.mercancias,
    solicitudCopia: state.solicitudCopia,
    cliente: state.cliente
});

const mapDispatchToProps = {
    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia,
    setRecoleccionOrigen: setRecoleccionOrigen,
    setRecoleccionDestino: setRecoleccionDestino,
    saveMercancias: saveMercancias
};

export default connect(mapStateToProps, mapDispatchToProps)(Markup);
